import { lazy } from "react";
import { Link } from "react-router-dom";
import './as.css';

const Search = lazy(() => import("./Search"));


const Header = () => {
  return (
    <header className="p-3 border-bottom bg-light">
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-md-4 text-center">
            <Link to="/">
              <img alt="logo" className="my_image " src="../../images/mylogo.svg" />
            </Link>
          </div>
          <div className="col-md-5 my_search">
            <Search />
          </div>
          
        </div>
      </div>
    </header>
  );
};
export default Header;
